module.exports = __webpack_public_path__ + "img/placket_length.0b2f476f.png";